import { ClosingAccountStoreStatic } from "./ClosingAccountStoreStatic";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../react-core/Flux/Dispatcher";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const ClosingAccountDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ClosingAccountStore: ClosingAccountStoreStatic = new ClosingAccountStoreStatic();
